import { FC, Fragment } from "react";
import {
    Text,
    Grid,
    Flex,
    Heading,
    useBreakpointValue,
} from "@smile2impress/components/relaunch";

import splitIntoColumns from "utils/clinics/splitIntoColumns";

import { CityGridProps } from "./CityGrid.types";
import { CityGridItem } from "./CityGridItem";

export const CityGrid: FC<CityGridProps> = ({
    title,
    cities,
    showFlagshipBadge = false,
    showInfoText = false,
    disclaimer = "",
}) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });
    const [mobileCitiesColumns, desktopCitiesColumns] = splitIntoColumns(
        cities,
        2,
        3
    );

    return (
        <>
            <Heading
                textStyle="title1"
                maxW={["100%", "100%", "50%"]}
                color="text.base"
            >
                {title}
            </Heading>
            <Grid
                templateColumns={[
                    "repeat(2, 1fr)",
                    "repeat(2, 1fr)",
                    "repeat(3, 1fr)",
                ]}
                columnGap={[2, 2, 5]}
                rowGap={2}
                mt={[3, 3, 4]}
            >
                {isMobile
                    ? mobileCitiesColumns.map((column, index) => (
                          <Flex
                              key={`mob-col-${index}`}
                              direction="column"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                              rowGap={2}
                          >
                              {column.map((city) => (
                                  <Fragment
                                      key={`${city.title || city.label}-${
                                          city.id
                                      }`}
                                  >
                                      <CityGridItem
                                          city={city}
                                          showFlagshipBadge={showFlagshipBadge}
                                      />
                                  </Fragment>
                              ))}
                          </Flex>
                      ))
                    : desktopCitiesColumns.map((column, index) => (
                          <Flex
                              key={`desk-col-${index}`}
                              direction="column"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                              rowGap={2}
                          >
                              {column.map((city) => (
                                  <Fragment
                                      key={`${city.title || city.label}-${
                                          city.id
                                      }`}
                                  >
                                      <CityGridItem
                                          city={city}
                                          showFlagshipBadge={showFlagshipBadge}
                                      />
                                  </Fragment>
                              ))}
                          </Flex>
                      ))}
            </Grid>
            {showInfoText && (
                <Text
                    textStyle="captionSmall"
                    fontStyle="italic"
                    color="base.halfBlack"
                    mt={[3, 3, 4]}
                >
                    {disclaimer}
                </Text>
            )}
        </>
    );
};
